import {ChangeDetectionStrategy, Component, HostBinding, Inject} from '@angular/core';
import {TISA_SIGN_IN_URL_PATH} from './premium-overlay.providers';
import {
  TISA_PREMIUM_OVERLAY_COMPONENT_ACTION_GOAL_LABEL,
  TISA_PREMIUM_OVERLAY_COMPONENT_ACTION_LABEL,
  TISA_PREMIUM_OVERLAY_COMPONENT_LABEL,
} from '@tisa-group/client-ui/tokens/premium-overlay-component';

@Component({
  selector: 'tisa-premium-overlay',
  templateUrl: './premium-overlay.component.html',
  styleUrls: ['premium-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PremiumOverlayComponent {
  @HostBinding('class')
  readonly className =
    'flex items-center justify-center bg-black-t-800 w-full h-full absolute inset-0 text-white-500 cursor-default';

  constructor(
    @Inject(TISA_SIGN_IN_URL_PATH) readonly signInPath: string,
    @Inject(TISA_PREMIUM_OVERLAY_COMPONENT_LABEL) readonly label: string,
    @Inject(TISA_PREMIUM_OVERLAY_COMPONENT_ACTION_LABEL) readonly actionLabel: string,
    @Inject(TISA_PREMIUM_OVERLAY_COMPONENT_ACTION_GOAL_LABEL)
    readonly actionGoalLabel: string,
  ) {}
}
